import productCard from "../product/product-card";
import Slider from '../slider';

// eslint-disable-next-line no-unused-vars
export default (element) => {
  productCard();
  const allSliders = element.querySelectorAll('[data-carousel]');
  const firstSliderElement = Array.from(allSliders)[0];
  const tabs = element.querySelectorAll('[data-tab]');
  const srBlock = element.querySelector('[data-sr-carousel]');

  let slider = null;

  const hideAllSliders = () => {
    allSliders.forEach((s) => {
      s.classList.add('hidden');
    })
  }

  const changeActiveTab = (activeTab) => {
    tabs.forEach((tab) => {
      const tabItem = tab;
      tabItem.classList.remove('text-black');
      tabItem.classList.add('text-grey-10');
      tabItem.ariaSelected = "false";
    });

    const tabToActivate = activeTab;
    tabToActivate.classList.remove('text-grey-10');
    tabToActivate.classList.add('text-black');
    tabToActivate.ariaSelected = "true";

    const equalizeEvent = new CustomEvent('equalizeProductCards', {
      bubbles: true, 
    });
    document.dispatchEvent(equalizeEvent);

  }

  const initSlider = (sl = firstSliderElement) => { 
    if(slider){
      slider.destroy(true, true);
    }
    const productCarousel = sl.querySelector('[data-product-carousel]')
    const paginationEl = sl.querySelector('[data-product-carousel-pagination]');
    const prevEl = sl.querySelector('[data-product-carousel-prev]');
    const nextEl = sl.querySelector('[data-product-carousel-next]');
    if (sl) {
      slider = new Slider({
        el: productCarousel,
        threshold: 20,
        options: { 
          a11y: {
            enabled: false,
          },
          slidesPerView: 2,
          spaceBetween: 10,
          slidesPerGroup: 2,
          loop: true,
          pagination: { 
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            1023: {
              slidesPerView: 4,
              slidesPerGroup: 1,
            }
          },
          navigation: {
            nextEl,
            prevEl,
          },
          on: {
            afterInit() {
              const { activeIndex, slides } = this;
              slides.slice(0, activeIndex).forEach((slide) => {
                const currentSlide = slide
                currentSlide.style.visibility = 'hidden';
              });
            },
            slideChange() {
              const { activeIndex, slides } = this;
              slides[activeIndex].style.visibility = ''; 
              slides.slice(0, activeIndex).forEach((slide) => {
                const currentSlide = slide
                currentSlide.style.visibility = ''; 
              });
            },
          }
        }
      });
      return slider;
    }
    return null;
  };

  const tabsHandler = (tab) => {
    hideAllSliders();
    srBlock.textContent = `Tab changed to ${tab.textContent}`
    const sliderIdentifier = tab.getAttribute('data-carousel-tab');
    const sliderElement = 
    element.querySelector(`[data-carousel-element="${sliderIdentifier}"]`);
    // Make the selected slider visible and initialize it
    if (sliderElement) {
      sliderElement.classList.remove('hidden');
      initSlider(sliderElement);
    }

    // Update the active tab styling
    changeActiveTab(tab);
  }

  const changeSliders = () => {
    tabs.forEach(tab => {
      tab.addEventListener('click', (event)=> {tabsHandler(event.currentTarget)});
    });
    tabs.forEach(tab => {
      tab.addEventListener('keydown', (event)=> {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          tabsHandler(event.currentTarget)
        }
       
      });
    });
  }
  

  initSlider();
  changeSliders();
};
